import FlippableCards from './FlippableCards'

export default FlippableCards
